import React from 'react';
import Loadable from 'react-loadable'
import { LoadingSpinner } from './components';
import CompanyInfoEntryDetail from './views/Home/CompanyInfo/CompanyInfoEntryDetail';
import RoleList01 from './views/Home/Role/RoleList';
import Featurelist from './views/Home/Feature/FeatureList';
import { components } from 'react-select';


function Loading() {
  return <LoadingSpinner />;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Login = Loadable({
  loader: () => import('./views/Pages/Login'),
  loading: Loading,
});

const SignUp = Loadable({
  loader: () => import('./views/Pages/SignUp/SignUp'),
  loading: Loading,
});

const ChangePassword = Loadable({
  loader: () => import('./views/Home/ChangePassword/ChangePassword'),
  loading: Loading,
});

const MyProfile = Loadable({
  loader: () => import('./views/Home/MyProfile/Profile'),
  loading: Loading,
});

const ProductTypeEntryDetail = Loadable({
  loader: () => import('./views/Home/ProductType/ProductTypeEntryDetail'),
  loading: Loading,
})
const ProductTypeEntryList = Loadable({
  loader: () => import('./views/Home/ProductType/ProductTypeEntryList'),
  loading: Loading,
})
const OperatorEntryDetail = Loadable({
  loader: () => import('./views/Home/Operator/OperatorEntryDetail'),
  loading: Loading,
})
const OperatorEntryList = Loadable({
  loader: () => import('./views/Home/Operator/OperatorEntryList'),
  loading: Loading,
})
const NewCompanyEntryDetail = Loadable({
  loader: () => import('./views/Home/CompanyInfo/NewCompanyEntryDetail'),
  loading: Loading,
})
const CompanyEntryList = Loadable({
  loader: () => import('./views/Home/CompanyInfo/CompanyEntryList'),
  loading: Loading,
})
const CompanyCommissionDetail = Loadable({
  loader: () => import('./views/Home/CompanyCommission/CompanyCommissionDetail'),
  loading: Loading,
})
const CompanyCommissionList = Loadable({
  loader: () => import('./views/Home/CompanyCommission/CompanyCommissionList'),
  loading: Loading,
})
const ProductEntryDetail = Loadable({
  loader: () => import('./views/Home/Product/ProductEntryDetail'),
  loading: Loading,
})
const ProductEntryList = Loadable({
  loader: () => import('./views/Home/Product/ProductEntryList'),
  loading: Loading,
})
const MasterSimEntryDetail = Loadable({
  loader: () => import('./views/Home/MasterSim/MasterSimEntryDetail'),
  loading: Loading,
})
const MasterSimEntryList = Loadable({
  loader: () => import('./views/Home/MasterSim/MasterSimEntryList'),
  loading: Loading,
})
const PrepaidEntry = Loadable({
  loader: () => import('./views/Home/PrePaid/PrepaidEntry'),
  loading: Loading,
})
const PrepaidList = Loadable({
  loader: () => import('./views/Home/PrePaid/PrepaidList'),
  loading: Loading,
})
const MSTraxEntryDetail = Loadable({
  loader: () => import('./views/Home/SimTransactions/MSTraxEntryDetail'),
  loading: Loading,
})
const MSTraxEntryList = Loadable({
  loader: () => import('./views/Home/SimTransactions/MSTraxEntryList'),
  loading: Loading,
})
const CounterPaymentList = Loadable({
  loader: () => import('./views/Home/CounterPayment/CounterPaymentList'),
  loading: Loading,
})
const TotalSalesList = Loadable({
  loader: () => import('./views/Home/TotalSales/TotalSalesList'),
  loading: Loading,
})
const UserEntryDetail = Loadable({
  loader: () => import('./views/Home/User/UserEntryDetail'),
  loading: Loading,
})
const UserEntryList = Loadable({
  loader: () => import('./views/Home/User/UserList'),
  loading: Loading,
})
const CounterCommissionInfo = Loadable({
  loader: () => import('./views/Home/User/CounterCommissionInfo'),
  loading: Loading,
})
const Page404 = Loadable({
  loader: () => import('./views/Pages/Page404'),
  loading: Loading,
})
const Page500 = Loadable({
  loader: () => import('./views/Pages/Page500'),
  loading: Loading,
})
const MasterScoreBoard = Loadable({
  loader: () => import('./views/Pages/ScoreBoard/'),
  loading: Loading,
})
/* KTZN 2023/03/2023 Start */
const TransactionList = Loadable({
  loader: () => import('./views/Home/TransactionList/TransactionList'),
  loading: Loading,
})
const TopUpRequestDetail = Loadable({
  loader: () => import('./views/Home/TopUpRequest/TopUpRequestDetail'),
  loading: Loading,
})
const E_loadIssueList = Loadable({
  loader: () => import('./views/Home/E_loadIssue/E_loadIssueList'),
  loading: Loading,
})
const RoleList = Loadable({
  loader: () => import('./views/Home/Role/RoleList'),
  loading: Loading,
})
const NewRole = Loadable({
  loader: () => import('./views/Home/Role/NewRole'),
  loading: Loading,
})
const FeatureList = Loadable({
  loader: () => import('./views/Home/Feature/FeatureList'),
  loading: Loading,
})
const FeatureEntry = Loadable({
  loader: () => import('./views/Home/Feature/FeatureEntry'),
  loading: Loading,
})
const E_pinDetail = Loadable({
  loader: () => import('./views/Home/E_pin/E_pinDetail'),
  loading: Loading,
})
const E_pinList = Loadable({
  loader: () => import('./views/Home/E_pin/E_pinList'),
  loading: Loading,
})
const E_pinReport = Loadable({
  loader: () => import('./views/Home/E_pin/E_pinReport'),
  loading: Loading,
})
const E_pinEdit = Loadable({
  loader: () => import('./views/Home/E_pin/E_pinEdit'),
  loading: Loading,
})
/* KTZN 2023/03/2023 End */

const routes = [
  //Root Routes
  { path: '/', exact: true, name: 'Home', component: Dashboard, type: "view" },
  { path: '/login', exact: true, name: 'Login', component: Login, type: "view" },
  { path: '/signUp', exact: true, name: 'SignUp', component: SignUp, type: "view" },
  { path: '/404', exact: true, name: '404', component: Page404, type: "view" },
  { path: '/500', exact: true, name: '500', component: Page500, type: "view" },

  //Report Routes 
  { path: '/report/dashboard', exact: true, name: 'Dashboard', component: Dashboard, type: "view" },
  {path: '/report/counter-payments', name: 'Counter Payments', component:CounterPaymentList, type: "view"},
  { path: '/report/summary', name: 'Summary', component: TransactionList, type: "view" },
  { path: '/report/total-sales', name: 'TotalSales', component: TotalSalesList, type: "view" },
  { path: '/report/epin-summary', name: 'E-pin Summary', component: E_pinReport, type: "view"},


  /// SetUp Routes
  { path: '/setup/user', name: 'Users', component: UserEntryList, type: "view" },
  { path: '/setup/user-entry', exact: true, name: 'New User', component: UserEntryDetail, type: "add" },
  { path: '/setup/user-entry/:id', name: 'Edit User', component: UserEntryDetail, type: "edit" },
  { path: '/setup/user-commission-info', name: 'Commission Info', component: CounterCommissionInfo, type: "view" },
  { path: '/setup/product', name: 'Products', component: ProductEntryList, type: "view" },
  { path: '/setup/product-entry', exact: true, name: 'New Product', component: ProductEntryDetail, type: "add" },
  { path: '/setup/product-entry/:id', name: 'Edit Product', component: ProductEntryDetail, type: "edit" },
  { path: '/setup/product-type', name: 'Product Types', component: ProductTypeEntryList, type: "view" },
  { path: '/setup/product-type-entry', exact: true, name: 'New ProductType', component: ProductTypeEntryDetail, type: "add" },
  { path: '/setup/product-type-entry/:id', name: 'Edit ProductType', component: ProductTypeEntryDetail, type: "edit" },
  { path: '/setup/operator', name: 'Operator', component: OperatorEntryList, type: "view" },
  { path: '/setup/operator-entry', exact: true, name: 'New Operator', component: OperatorEntryDetail, type: "add" },
  { path: '/setup/operator-entry/:id', name: 'Edit Operator', component: OperatorEntryDetail, type: "edit" },

  { path: '/setup/master-sim', name: 'Master SIMs', component: MasterSimEntryList, type: "view" },
  { path: '/setup/master-sim-entry', exact: true, name: 'New Master SIM', component: MasterSimEntryDetail, type: "add" },
  { path: '/setup/master-sim-entry/:id', name: 'Edit Master SIM', component: MasterSimEntryDetail, type: "edit" },

  { path: '/setup/role', name: 'Role List', component: RoleList, type: "view" },
  { path: '/setup/role-entry', exact: true, name: 'New Role', component: NewRole, type: "add" },
  { path: '/setup/role-entry/:id', name: 'Edit Role', component: NewRole, type: "edit" },

  { path: '/setup/feature', name: 'Feature List', component: FeatureList, type: "view" },
  { path: '/setup/feature-entry', exact: true, name: 'New Feature', component: FeatureEntry, type: "add" },
  { path: '/setup/feature-entry/:id', name: 'Edit Feature', component: FeatureEntry, type: "edit" },

  { path: '/setup/e-pin', name: 'E-pin', component: E_pinList, type: "view" },
  { path: '/setup/e-pin-entry', exact: true, name: 'New E-pin', component: E_pinDetail, type: "add" },
  { path: '/setup/e-pin-entry/:id', name: 'Edit E-pin', component: E_pinDetail, type: "edit" },

  { path: '/setup/e-pin-edit/:id', name: 'Edit E-pin', component: E_pinEdit, type: "edit"},


  ///Every Login User Routes
  { path: '/user/changepassword', name: 'Change Password', component: ChangePassword },
  { path: '/user/myprofile', name: 'My Profile', component: MyProfile },


  /// Trxs Routes
  { path: '/trx/request', exact: true, name: 'Request', component: TopUpRequestDetail, type: "view" },
  { path: '/trx/issues', exact: true, name: 'TopUp', component: E_loadIssueList, type: "view" },
  { path: '/trx/master-sim', name: 'SIM Transactions', component: MSTraxEntryList, type: "view" },
  { path: '/trx/master-sim-entry', exact: true, name: 'New SIM Transactions', component: MSTraxEntryDetail, type: "add" },
  { path: '/trx/master-sim-entry/:id', name: 'Edit SIM Transactions', component: MSTraxEntryDetail, type: "edit" },
  { path: '/trx/prepaid', name: 'Prepaid Transactions', component: PrepaidList, type: "view" },
  { path: '/trx/prepaid-entry', exact: true, name: 'New Prepaid Transactions', component: PrepaidEntry, type: "add" },
  { path: '/trx/prepaid-entry/:id', name: 'Edit Prepaid Transactions', component: PrepaidEntry, type: "edit" },


  ///Info Routes
  { path: '/info/commission', name: 'Global Commission', component: CompanyCommissionList, type: "view" },
  { path: '/info/commission-entry', exact: true, name: 'New Global Commission', component: CompanyCommissionDetail, type: "add" },
  { path: '/info/commission-entry/:id', name: 'Edit Global Commission', component: CompanyCommissionDetail, type: "edit" },
  { path: '/info/company-entry', exact: true, name: 'Edit Company ', component: CompanyInfoEntryDetail, type: "edit" },
  { path: '/info/company-entry/:id', name: 'Edit Company', component: CompanyInfoEntryDetail, type: "edit" },
  { path: '/info/company', name: 'Companies', component: CompanyEntryList, type: "view" },
  { path: '/info/company-new', exact: true, name: 'New Company', component: NewCompanyEntryDetail, type: "add" },

  

];

export default routes;